const GroupIcon = "/assets/ret-1.png";
const Group1Icon = "/assets/ret-2.png";
const Group2Icon = "/assets/ret-3.png";
const Group15Icon = "/assets/ret-4.png";
const Group13Icon = "/assets/ret-5.png";
const VectorIcon = "/assets/ret-6.png";

const features = [
  { icon: GroupIcon, color: "#3B82F6" },
  { icon: Group1Icon, color: "#F59E0B" },
  { icon: Group2Icon, color: "#66A0CD" },
  { icon: Group15Icon, color: "#1D2C56" },
  { icon: Group13Icon, color: "#F87171" },
  { icon: VectorIcon, color: "#8B5CF6" },
];

const RetirementPlan = () => {
  return (
    <section className="mx-auto my-4 w-full px-4 sm:p-8 md:my-8 md:max-w-[90%] lg:my-16 lg:rounded-[30px] lg:p-10 lg:px-10">
      <div className="flex w-full flex-col items-center justify-start gap-0 md:gap-8 lg:gap-12">
        {/* Title */}
        <div className="space-y-2 text-center sm:space-y-4">
          <h2 className="text-center font-sans text-2xl font-bold leading-tight text-[var(--P1,#1D2C56)] sm:text-3xl lg:text-5xl lg:leading-[60px]">
            Build Your Retirement Plan
          </h2>
        </div>

        {/* Icons Grid */}
        <div className="mx-auto mt-7 grid w-full grid-cols-2 sm:gap-8 md:mt-16 md:max-w-[90%] md:grid-cols-3 lg:grid-cols-6">
          {features.map((feature, index) => {
            // Cards 2, 4, and 6 (index 1, 3, 5)
            const isRaised = [1, 3, 5].includes(index);

            return (
              <div
                key={feature.color}
                className={`relative flex cursor-pointer flex-col items-center text-center transition-transform duration-1000 ease-in-out hover:-translate-y-[10px] ${
                  isRaised ? "mt-0 lg:-mt-[60px]" : ""
                }`}
              >
                <div>
                  <img
                    src={feature.icon}
                    alt={`Feature ${index + 1}`}
                    className="h-40 w-40 object-contain md:h-full md:w-full"
                  />
                </div>

                {/* <h4 className="mt-3 font-sans text-sm font-semibold leading-snug text-gray-800 sm:text-base">
                  {feature.title}
                </h4> */}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RetirementPlan;
